// eslint-disable-next-line import/prefer-default-export
export const AUDIT_TASK_ERROR_CODES = {
  INVALID_SESSION_ACTIVITY_STATUS: 'invalid-session-activity-status',
  AI_UNAVAILABLE: 'ai-unavailable',
};
